import { useQuery } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import useOrgId from 'hooks/useOrgId.js';
import { useFeatureContext } from 'contexts/FeatureContext.jsx';

const getQueryKey = (orgId, shopperId) => ['o', orgId, 'shopperInfo', shopperId];
export { getQueryKey };

const useShopperInformation = (shopperId) => {
  const firebase = useFirebase();
  const orgId = useOrgId();
  const { features } = useFeatureContext();

  const { allowBlockChatParticipantByIPAddressEnabled } = features;

  const baseUrl = `/o/${encodeURIComponent(orgId)}/shopperInformation`;

  return useQuery({
    queryKey: getQueryKey(orgId, shopperId),
    queryFn: async () => {
      if (!shopperId) return {};
      const agent = await firebase.getAgent();
      const { body = {}, headers } = await agent.get(`${baseUrl}?shopperId=${shopperId}`);

      return {
        ...body,
        ownIPAddress: headers['caller-ip-address'],
      };
    },
    enabled: allowBlockChatParticipantByIPAddressEnabled,
  });
};

export default useShopperInformation;
